var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { AppContextEnum, DestinationEnum, EventNameEnum } from './types/enums';
import { DEFAULT_DESTINATIONS } from './types/constants';
export function mapDestinations(initState, options, eventName) {
    return overrideDestinations({
        requestedDestinations: typeof (options === null || options === void 0 ? void 0 : options.destinations) !== 'undefined' ? options.destinations : initState.destinations,
        appContext: initState.application.context,
        anonymousId: initState.user.anonymousId,
        optInStatistics: initState.user.optins.statistics,
        eventName: eventName,
    });
}
var eventsForHumio = [EventNameEnum.FormStepCompleted];
var eventsWithPredefinedDestinations = __spreadArray([], eventsForHumio, true);
export function overrideDestinations(destinationProps) {
    var destinations = intersection(destinationProps.requestedDestinations, getPossibleDestinationsForClient(destinationProps));
    if (destinationProps.eventName &&
        eventsWithPredefinedDestinations.indexOf(destinationProps.eventName) > -1) {
        destinations = intersection(destinations, getPossibleDestinationsForEvent(destinationProps));
    }
    return destinations;
}
function getPossibleDestinationsForClient(destinationProps) {
    switch (destinationProps.appContext) {
        case AppContextEnum.aapneSider:
            if (destinationProps.optInStatistics) {
                return DEFAULT_DESTINATIONS;
            }
            else {
                return [];
            }
        case AppContextEnum.digitalbank:
            if (destinationProps.optInStatistics) {
                return DEFAULT_DESTINATIONS;
            }
            else {
                return [DestinationEnum.Humio];
            }
        case AppContextEnum.intern:
            return [DestinationEnum.Humio];
        case AppContextEnum.kreditt:
            return destinationProps.requestedDestinations;
        case AppContextEnum.fremtind:
            return destinationProps.requestedDestinations;
        case AppContextEnum.eiendomsmegler1:
            if (destinationProps.optInStatistics) {
                return destinationProps.requestedDestinations.filter(function (d) { return d !== DestinationEnum.Datavarehus; });
            }
            else {
                return [];
            }
        default:
            console.warn("web-behavior-tracker was initialized with an invalid appContext: ".concat(destinationProps.appContext, ". Make sure you are using a valid appContext when initiating the tracker."));
            return [];
    }
}
export function getPossibleDestinationsForEvent(destinationProps) {
    var eventsForHumio = [EventNameEnum.FormStepCompleted];
    if (destinationProps.eventName && eventsForHumio.indexOf(destinationProps.eventName) > -1) {
        return ['HUMIO'];
    }
    return destinationProps.requestedDestinations;
}
export function intersection(possibleDestinations, requestedDestinations) {
    var _intersection = new Set();
    var possibleDestinationsAsSet = new Set(possibleDestinations);
    for (var _i = 0, requestedDestinations_1 = requestedDestinations; _i < requestedDestinations_1.length; _i++) {
        var elem = requestedDestinations_1[_i];
        if (possibleDestinationsAsSet.has(elem)) {
            _intersection.add(elem);
        }
    }
    return Array.from(_intersection);
}
//# sourceMappingURL=mapDestinations.js.map